export default __webpack_public_path__ + "static/media/BookingToolBlockQuoteDesktop.167290aa.png";